var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.level == 1)?_c('h1',{staticClass:"h1"},[_vm._t("default")],2):_vm._e(),(_vm.level == 2)?_c('h2',{staticClass:"h2"},[_vm._t("default")],2):_vm._e(),(_vm.level === null)?_c('span',{class:_vm.styling},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }